import { SepaTransactionStatus } from '@allocab/allocab-invoice-service-types';

import { BadgeIndicator, IndicatorVariant } from '../../components/BadgeIndicator';
import { t } from '../../services/translation/translation';
import { assertNever } from '../../utils/common';

type Props = {
  status: SepaTransactionStatus | 'CURRENT';
};

const getTextForStatus = (status: SepaTransactionStatus | 'CURRENT') => {
  switch (status) {
    case 'IN_PROCESS':
      return t('transaction.tabs.upcoming');
    case 'VALIDATED':
      return t('transaction.tabs.done');
    case 'REJECTED':
      return t('transaction.tabs.rejected');
    case 'CANCELLED':
      return t('transaction.tabs.cancelled');
    case 'CURRENT':
      return t('transaction.tabs.current');
    default:
      assertNever(status, `[TransactionStateBadge - getTextForStatus] state unknown: ${status}`);
      return '';
  }
};

const getVariantForStatus = (status: SepaTransactionStatus | 'CURRENT'): IndicatorVariant => {
  switch (status) {
    case 'IN_PROCESS':
      return 'blue';
    case 'VALIDATED':
      return 'green';
    case 'REJECTED':
      return 'red';
    case 'CANCELLED':
      return 'gray';
    case 'CURRENT':
      return 'yellow';
    default:
      assertNever(status, `[TransactionStateBadge - getVariantForStatus] state unknown: ${status}`);
      return 'gray';
  }
};

export const TransactionStateBadge = ({ status }: Props) => {
  return <BadgeIndicator variant={getVariantForStatus(status)}>{getTextForStatus(status)}</BadgeIndicator>;
};
